import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiTarget, FiHeart, FiUsers, FiShield } from 'react-icons/fi';

const About = () => {
  return (
    <div className="bg-brand-cream min-h-screen">
      {/* Hero */}
      <div className="bg-brand-green py-24 relative overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://adafrofood.com/files/local-image-small-616.png" 
            alt="Market Background" 
            className="w-full h-full object-cover opacity-10 mix-blend-overlay"
          />
        </div>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center">
          <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6">About DSGlobal Foundation</h1>
          <div className="w-24 h-1 bg-brand-yellow mx-auto mb-8"></div>
          <p className="text-xl text-gray-200 leading-relaxed">
            DSGlobal Foundation is presented as an African food product supplier focused on bringing authentic Ghanaian and African food products to international customers, shops and wholesale partners.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        
        {/* Content Section with Image */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          <div>
            <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-6">Connecting Cultures Through Food</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              Our mission is to make high-quality, authentic African food products accessible to everyone. Whether you are recreating the comforting taste of home, running a busy restaurant, or stocking a retail store, we provide the essential ingredients you need.
            </p>
            <p className="text-gray-600 leading-relaxed">
              We specialize in Ghanaian staples—from smooth fufu flours and rich palm oils to fresh produce and pantry essentials. We understand that quality ingredients are the foundation of great African cuisine.
            </p>
          </div>
          <div className="relative">
            <div className="absolute inset-0 bg-brand-yellow rounded-2xl transform translate-x-4 translate-y-4 opacity-20"></div>
            <img 
              src="https://adafrofood.com/files/local-image-small-616.png" 
              alt="African Food Ingredients" 
              className="rounded-2xl shadow-lg relative z-10 w-full object-cover h-80"
            />
          </div>
        </div>

        {/* Four Pillars */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-white p-10 rounded-2xl shadow-sm border border-brand-sand flex flex-col md:flex-row gap-6 items-start">
            <div className="w-14 h-14 bg-brand-sand rounded-full flex items-center justify-center flex-shrink-0">
              <SafeIcon icon={FiTarget} className="w-6 h-6 text-brand-green" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-brand-charcoal mb-3">Our Focus: African Food Products</h3>
              <p className="text-gray-600 leading-relaxed">
                We concentrate exclusively on authentic food supplies, ensuring our catalog reflects the genuine tastes and essential ingredients required for traditional African cooking.
              </p>
            </div>
          </div>

          <div className="bg-white p-10 rounded-2xl shadow-sm border border-brand-sand flex flex-col md:flex-row gap-6 items-start">
            <div className="w-14 h-14 bg-brand-sand rounded-full flex items-center justify-center flex-shrink-0">
              <SafeIcon icon={FiHeart} className="w-6 h-6 text-brand-red" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-brand-charcoal mb-3">Our Roots: Ghanaian Food Heritage</h3>
              <p className="text-gray-600 leading-relaxed">
                With a strong appreciation for Ghanaian culinary traditions, we carefully select products that honor traditional recipes, offering authentic options like plantain fufu and zomi palm oil.
              </p>
            </div>
          </div>

          <div className="bg-white p-10 rounded-2xl shadow-sm border border-brand-sand flex flex-col md:flex-row gap-6 items-start">
            <div className="w-14 h-14 bg-brand-sand rounded-full flex items-center justify-center flex-shrink-0">
              <SafeIcon icon={FiUsers} className="w-6 h-6 text-brand-yellow" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-brand-charcoal mb-3">Our Customers</h3>
              <p className="text-gray-600 leading-relaxed">
                We proudly serve diverse clientele, from families preparing daily meals to retail shops, bustling restaurants, and scale-focused wholesale buyers.
              </p>
            </div>
          </div>

          <div className="bg-white p-10 rounded-2xl shadow-sm border border-brand-sand flex flex-col md:flex-row gap-6 items-start">
            <div className="w-14 h-14 bg-brand-sand rounded-full flex items-center justify-center flex-shrink-0">
              <SafeIcon icon={FiShield} className="w-6 h-6 text-brand-charcoal" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-brand-charcoal mb-3">Our Promise</h3>
              <p className="text-gray-600 leading-relaxed">
                We commit to clear communication, highly practical service, and delivering authentic products. Your satisfaction and trust are the foundations of our business.
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default About;